import React, { useState } from 'react';
import {
  FDBodyText,
  FDBox,
  FDClickableText,
  FDDialogActions,
  FDDialogContent,
  FDPaper,
  FDPrimaryActionButton,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { navigateToPageInNewTab } from 'Views/Page/Content/Templates';

const JustWinPM1Layout = () => {
  const { onSubmit, resource } = useMetaLayoutContext();
  const [accountsExpanded, setAccountsExpanded] = useState(false);

  const accounts = resource.withRelationship(
    fr.relationships.accounts.name,
    (rel) => rel.getRelated().resources().list(),
    () => [],
  );

  const readonly = !resource.meta().action('PUT') && !resource.meta().action('POST');

  return (
    <FDBox>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={2}>
          <MetaControlField attr={'subtitle'} />
          <MetaControlField attr={'description'} />
          <FDStack direction={'row'} spacing={2}>
            {accounts.length > 0 ? (
              <FDPaper width={'100%'} padding={2}>
                <FDStack direction={'column'} spacing={1}>
                  {accounts
                    .slice(0, !accountsExpanded ? 3 : undefined)
                    .map((res) => (
                      <FDBodyText value={res.attr('name')} />
                    ))}
                  {accounts.length > 3 ? <FDClickableText appearance={'standalone'} onClick={() => setAccountsExpanded(!accountsExpanded)} label={accountsExpanded ? 'See Less' : 'See More...'} /> : null}
                </FDStack>
              </FDPaper>
            ) : null}
          </FDStack>
          <MetaLayoutRemainingFields noAccordion />
        </FDStack>
      </FDDialogContent>
      {!readonly ? (
        <FDDialogActions>
          <FDStack spacing={2} width={'100%'} alignItems={'flex-start'}>
            <FDPrimaryActionButton label={'Save and close'} onClick={onSubmit} />
            {!readonly && resource.withRelationship(
              fr.relationships.openAccount.name,
              (rel) => (
                <FDSecondaryActionButton
                  onClick={() => navigateToPageInNewTab(rel.link('related').url(), true)}
                  icon={'add'}
                  label={rel.meta('prompt') || 'Create account action'}
                  openInNewTab
                />
              ),
              () => null,
            )}
          </FDStack>
        </FDDialogActions>
      ) : null}
    </FDBox>
  );
};

JustWinPM1Layout.defaultProps = {};

JustWinPM1Layout.propTypes = {};

export { JustWinPM1Layout };
